import dashboardRequest, { viewRequest } from '@/pages/dashboard/utils/dashboardRequest';

export const getApiData: (api: string, data: any, ignoreRequestId?: boolean) => Promise<any> = (api, data, ignoreRequestId) => {
  const options = {
    url: api,
    method: 'post',
    data,
    ignoreRequestId
  };
  return viewRequest(options);
};

//  retention - download
export const downLoadApi: (api: string, data: any) => Promise<any> = (api, data) => {
  const options = {
    url: api,
    method: 'post',
    data,
    responseType: 'arraybuffer',
    rawData: true,
  };
  return dashboardRequest(options);
};